var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BasicHeader mimenu-row center",class:{ fixed: _vm.isFixed }},[_c('img',{attrs:{"src":"/assets/todos-comemos-logo.svg","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }